// Get algorithm options list
export const getAlgorithmOptions = (algorithms) => {
  // Convert algorithms object to array
  const algorithmsArray = Object.entries(algorithms);
  
  // Custom sort: put capacitated_savings at the top
  algorithmsArray.sort((a, b) => {
    if (a[0] === 'capacitated_savings') return -1;
    if (b[0] === 'capacitated_savings') return 1;
    return 0;
  });
  
  // Map to option elements
  return algorithmsArray.map(([value, info]) => (
    <option key={value} value={value}>
      {info.name}
    </option>
  ));
};

// Process vehicle paths from API response
export const processVehiclePaths = (result) => {
  if (result.vehiclePaths && result.vehiclePaths.length > 0) {
    // Multi-vehicle path case - handle first

    // Set path - directly use result.path, but attach vehiclePaths metadata
    // Key: create a real path array and attach vehiclePaths
    const combinedPath = [...result.path];
    // Ensure it's an array, attach vehiclePaths as property to array object
    combinedPath.vehiclePaths = result.vehiclePaths;
    
    return {
      processedPath: combinedPath,
      processedResult: {
        ...result,
        path: combinedPath,
        vehiclePaths: result.vehiclePaths,
        min_vehicles_needed: result.min_vehicles_needed
      }
    };
  }
  else if (result.geojson && result.geojson.type === 'FeatureCollection') {
    // Use complete GeoJSON format

    // Set path - include GeoJSON and vehiclePaths
    const pathWithMetadata = [...result.path];
    if (result.vehiclePaths) {
      pathWithMetadata.vehiclePaths = result.vehiclePaths;
    }
    
    return {
      processedPath: pathWithMetadata,
      pathMetadata: { 
        custom: result.geojson,  // Save complete GeoJSON
        vehiclePaths: result.vehiclePaths  // Save vehicle path information
      },
      processedResult: {
        ...result,
        path: pathWithMetadata,
        vehiclePaths: result.vehiclePaths,
        min_vehicles_needed: result.min_vehicles_needed
      }
    };
  } 
  else if (result.isVrp && result.vehiclePaths && result.vehiclePaths.length > 0) {
    // For VRP algorithm, pass vehicle_paths metadata

    const pathWithMetadata = [...result.path];
    pathWithMetadata.vehiclePaths = result.vehiclePaths;
    
    return {
      processedPath: pathWithMetadata,
      pathMetadata: { vehiclePaths: result.vehiclePaths },
      processedResult: {
        ...result,
        path: pathWithMetadata,
        vehiclePaths: result.vehiclePaths,
        min_vehicles_needed: result.min_vehicles_needed
      }
    };
  } 
  else {
    // For traditional TSP algorithm, only pass path

    return {
      processedPath: result.path,
      processedResult: result
    };
  }
}; 